import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

const Styles = createGlobalStyle`
  :root {
    --brandColor1: #07F49E;
    --brandColor2: #42047E;
  }

  ${normalize}

  html {
    box-sizing: border-box;
    font-size: 62.5%;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font: 1.6rem / 1.5 system-ui;
  }

  svg {
    display: block;
  }
`

export default Styles
